<template lang="html">
  <flickity ref="flickity"
  :options="flickityOptions" class="collection-slider-main">
    <template v-for="(product) in products">
      <div class="carousel-cell" :key="product.id">
        <ProductCard
        :inSlider="true"
        :data="JSON.stringify(product.productData)" 
        :quickviewData="JSON.stringify(product.quickview)" 
        v-on:sliderQuickview="sendDataToSliderModal"/>
      </div>
    </template>
  </flickity>
</template>

<script>
  import Flickity from 'vue-flickity';
  import ProductCard from 'scripts/components/product/ProductCard.vue';

  export default {
    name: 'CollectionSlider',
    components: {
      Flickity,
      ProductCard
    },
    props: {
      data: {
        type: String,
        required: true
      }
    },
    computed: {
      collectionData() {
        return JSON.parse(this.data);
      },
      products() {
        return this.collectionData.products;
      }
    },
    methods: {
      sendDataToSliderModal(data) {
        this.$emit('sendToModal', data)
      }
    },
    data() {
      return {
        flickityOptions: {
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          draggable: true,
          resize: true,
          groupCells: '100%',
          adaptiveHeight: false,
          prevNextButtons: true,
          imagesLoaded: true,
          setGallerySize: false,
          wrapAround: true
        }
      }
    },
    mounted() {}
  }
</script>

<style lang="scss" scoped></style>
